module.exports = __webpack_public_path__ + "static/media/trip-7.ba4b6c9d.png";